// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@master/css/themify-icons.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --fd-green: #1a7a4a;
  --fd-green-light: #23a862;
  --fd-green-dark: #0f4d2d;
  --fd-gold: #e8b04b;
  --fd-gold-light: #f5ca70;
  --fd-dark: #0d1117;
  --fd-surface: #161b22;
  --fd-surface2: #1e252e;
  --fd-surface3: #252c36;
  --fd-border: rgba(255,255,255,0.08);
  --fd-text: #e6edf3;
  --fd-muted: #8b949e;
  --fd-red: #cf6679;
  --fd-blue: #58a6ff;
  --font-head: 'Barlow Condensed', sans-serif;
  --font-body: 'Barlow', sans-serif;
}

body {
  background: var(--fd-dark);
  color: var(--fd-text);
  font-family: var(--font-body);
  font-size: 14px;
  min-height: 100vh;
  overflow-x: hidden;
}

.app-shell {
  display: flex;
  height: 100vh;
  min-height: 700px;
  position: relative;
  overflow: hidden;
}

/* SIDEBAR */
.sidebar {
  width: 220px;
  flex-shrink: 0;
  background: var(--fd-surface);
  border-right: 1px solid var(--fd-border);
  display: flex;
  flex-direction: column;
  padding: 0;
  z-index: 10;
}

.logo {
  padding: 20px 16px 16px;
  border-bottom: 1px solid var(--fd-border);
}

.logo-text {
  font-family: var(--font-head);
  font-size: 26px;
  font-weight: 900;
  letter-spacing: -0.5px;
  color: var(--fd-text);
  text-transform: uppercase;
}

.logo-text span {
  color: var(--fd-green-light);
}

.logo-sub {
  font-size: 10px;
  color: var(--fd-muted);
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-top: 2px;
}

.nav {
  padding: 12px 8px;
  flex: 1 1;
  overflow-y: auto;
}

.nav-label {
  font-size: 10px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--fd-muted);
  padding: 8px 8px 4px;
  font-weight: 600;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: var(--fd-muted);
  transition: all 0.15s;
  margin-bottom: 2px;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
}

.nav-item:hover { background: var(--fd-surface2); color: var(--fd-text); }
.nav-item.active { background: rgba(26,122,74,0.2); color: var(--fd-green-light); }
.nav-item .ti { font-size: 18px; }

.nav-item .badge {
  margin-left: auto;
  background: var(--fd-green);
  color: #fff;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 6px;
  min-width: 18px;
  text-align: center;
}

.sidebar-bottom {
  padding: 12px 8px;
  border-top: 1px solid var(--fd-border);
}

.user-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}

.user-pill:hover { background: var(--fd-surface2); }

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--fd-green), var(--fd-green-dark));
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-head);
  font-size: 14px;
  font-weight: 800;
  color: #fff;
  flex-shrink: 0;
  position: relative;
}

.avatar.verified::after {
  content: '✓';
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 14px;
  height: 14px;
  background: var(--fd-blue);
  border-radius: 50%;
  font-size: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 1.5px solid var(--fd-surface);
  font-weight: 900;
  line-height: 14px;
  text-align: center;
}

.user-info-small .name { font-size: 13px; font-weight: 600; }
.user-info-small .handle { font-size: 11px; color: var(--fd-muted); }

/* MAIN CONTENT */
.main {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--fd-dark);
}

/* PAGES */
.page { display: none; }
.page.active { display: block; }

/* FEED PAGE */
.page-header {
  position: sticky;
  top: 0;
  z-index: 5;
  background: rgba(13,17,23,0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--fd-border);
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.page-title {
  font-family: var(--font-head);
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.live-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(207,102,121,0.15);
  border: 1px solid rgba(207,102,121,0.3);
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 700;
  color: var(--fd-red);
}

.pulse-dot {
  width: 7px;
  height: 7px;
  background: var(--fd-red);
  border-radius: 50%;
  animation: pulse 1.4s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.8); }
}

.feed-content { padding: 20px 24px; }

/* SCORE CARDS */
.score-card {
  background: var(--fd-surface);
  border: 1px solid var(--fd-border);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
}

.score-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--fd-green), transparent);
}

.score-card.live::before { background: linear-gradient(90deg, var(--fd-red), transparent); }

.score-card:hover { border-color: rgba(255,255,255,0.15); transform: translateY(-1px); }

.score-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.sport-tag {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--fd-muted);
}

.live-tag {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--fd-red);
  background: rgba(207,102,121,0.12);
  padding: 2px 8px;
  border-radius: 10px;
}

.score-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.team-block {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.team-block.right { flex-direction: row-reverse; text-align: right; }

.team-logo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-head);
  font-size: 13px;
  font-weight: 900;
  flex-shrink: 0;
}

.team-name {
  font-family: var(--font-head);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.team-record {
  font-size: 11px;
  color: var(--fd-muted);
  margin-top: 1px;
}

.score-center {
  text-align: center;
  min-width: 90px;
}

.score-nums {
  font-family: var(--font-head);
  font-size: 32px;
  font-weight: 900;
  letter-spacing: -1px;
  line-height: 1;
}

.score-period {
  font-size: 11px;
  color: var(--fd-muted);
  margin-top: 4px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.score-card-footer {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--fd-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.betting-line {
  font-size: 12px;
  color: var(--fd-gold);
  font-weight: 600;
}

.chat-count {
  font-size: 12px;
  color: var(--fd-muted);
  display: flex;
  align-items: center;
  gap: 4px;
}

/* SECTION TITLE */
.section-title {
  font-family: var(--font-head);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--fd-muted);
  margin: 20px 0 10px;
}

/* GAME DETAIL PAGE */
.game-detail-layout {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 0;
  height: 100%;
}

.game-main { padding: 0; overflow-y: auto; }
.game-sidebar { border-left: 1px solid var(--fd-border); overflow-y: auto; background: var(--fd-surface); }

.big-scoreboard {
  background: var(--fd-surface);
  border-bottom: 1px solid var(--fd-border);
  padding: 24px;
}

.big-score-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.big-team {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 14px;
}

.big-team.right { flex-direction: row-reverse; text-align: right; }

.big-logo {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-head);
  font-size: 18px;
  font-weight: 900;
  flex-shrink: 0;
}

.big-team-name {
  font-family: var(--font-head);
  font-size: 24px;
  font-weight: 800;
  text-transform: uppercase;
}

.big-score {
  text-align: center;
}

.big-score-nums {
  font-family: var(--font-head);
  font-size: 52px;
  font-weight: 900;
  letter-spacing: -2px;
  line-height: 1;
}

.big-score-period {
  font-size: 13px;
  font-weight: 700;
  color: var(--fd-red);
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: 4px;
}

.odds-bar {
  display: flex;
  gap: 16px;
  padding: 12px 24px;
  background: rgba(232,176,75,0.06);
  border-bottom: 1px solid var(--fd-border);
  align-items: center;
}

.odd-item {
  font-size: 12px;
  color: var(--fd-muted);
}

.odd-item span {
  color: var(--fd-gold);
  font-weight: 700;
  margin-left: 4px;
}

/* TABS */
.tabs {
  display: flex;
  border-bottom: 1px solid var(--fd-border);
  padding: 0 24px;
  background: var(--fd-dark);
  position: sticky;
  top: 53px;
  z-index: 4;
}

.tab {
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--fd-muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.15s;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  font-family: var(--font-head);
}

.tab.active { color: var(--fd-green-light); border-bottom-color: var(--fd-green-light); }
.tab:hover:not(.active) { color: var(--fd-text); }

/* CHAT */
.chat-section { padding: 16px; }

.chat-input-area {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  align-items: flex-end;
}

.chat-input {
  flex: 1 1;
  background: var(--fd-surface2);
  border: 1px solid var(--fd-border);
  border-radius: 10px;
  padding: 10px 14px;
  color: var(--fd-text);
  font-family: var(--font-body);
  font-size: 13px;
  resize: none;
  min-height: 40px;
  max-height: 80px;
  outline: none;
}

.chat-input:focus { border-color: var(--fd-green); }

.send-btn {
  background: var(--fd-green);
  border: none;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  transition: background 0.15s;
  flex-shrink: 0;
}

.send-btn:hover { background: var(--fd-green-light); }

.chat-message {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
  align-items: flex-start;
}

.msg-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-head);
  font-size: 11px;
  font-weight: 800;
  flex-shrink: 0;
  position: relative;
}

.msg-avatar.verified::after {
  content: '✓';
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background: var(--fd-blue);
  border-radius: 50%;
  font-size: 7px;
  line-height: 12px;
  text-align: center;
  color: #fff;
  border: 1.5px solid var(--fd-dark);
  font-weight: 900;
}

.msg-body { flex: 1 1; }

.msg-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 3px;
}

.msg-name {
  font-size: 13px;
  font-weight: 600;
}

.msg-handle { font-size: 11px; color: var(--fd-muted); }
.msg-time { font-size: 11px; color: var(--fd-muted); margin-left: auto; }

.msg-text {
  font-size: 13px;
  line-height: 1.5;
  color: var(--fd-text);
  background: var(--fd-surface2);
  padding: 8px 12px;
  border-radius: 0 10px 10px 10px;
  display: inline-block;
  max-width: 100%;
}

.foam-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}

.foam-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid var(--fd-border);
  border-radius: 20px;
  padding: 3px 10px;
  cursor: pointer;
  font-size: 12px;
  color: var(--fd-muted);
  transition: all 0.15s;
  font-family: var(--font-body);
}

.foam-btn:hover, .foam-btn.active {
  background: rgba(232,176,75,0.12);
  border-color: rgba(232,176,75,0.4);
  color: var(--fd-gold);
}

.foam-icon { font-size: 14px; }

/* REVIEW CARD */
.review-card {
  background: var(--fd-surface2);
  border: 1px solid var(--fd-border);
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
}

.review-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.stars {
  display: flex;
  gap: 2px;
  margin-left: auto;
}

.star { color: var(--fd-gold); font-size: 14px; }
.star.empty { color: var(--fd-muted); }

.review-text {
  font-size: 13px;
  line-height: 1.6;
  color: var(--fd-text);
  margin-bottom: 10px;
}

.review-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.visibility-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 20px;
}

.visibility-badge.public {
  background: rgba(35,168,98,0.15);
  color: var(--fd-green-light);
}

.visibility-badge.friends {
  background: rgba(88,166,255,0.12);
  color: var(--fd-blue);
}

/* PROFILE PAGE */
.profile-hero {
  height: 120px;
  background: linear-gradient(135deg, var(--fd-green-dark) 0%, #0d1117 100%);
  position: relative;
}

.profile-content { padding: 0 24px 24px; }

.profile-avatar-wrap {
  margin-top: -30px;
  margin-bottom: 12px;
}

.profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--fd-green), var(--fd-green-dark));
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-head);
  font-size: 24px;
  font-weight: 900;
  color: #fff;
  border: 3px solid var(--fd-dark);
  position: relative;
}

.profile-avatar.verified::after {
  content: '✓';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: var(--fd-blue);
  border-radius: 50%;
  font-size: 10px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  border: 2px solid var(--fd-dark);
  font-weight: 900;
}

.profile-name {
  font-family: var(--font-head);
  font-size: 22px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.profile-handle { font-size: 13px; color: var(--fd-muted); margin-top: 2px; }
.profile-bio { font-size: 13px; color: var(--fd-text); margin: 8px 0; line-height: 1.5; }

.profile-stats {
  display: flex;
  gap: 20px;
  margin: 12px 0;
}

.profile-stat {
  text-align: center;
}

.profile-stat .num {
  font-family: var(--font-head);
  font-size: 20px;
  font-weight: 800;
}

.profile-stat .label {
  font-size: 11px;
  color: var(--fd-muted);
  margin-top: 1px;
}

.profile-actions {
  display: flex;
  gap: 8px;
  margin: 14px 0;
}

.btn-primary {
  background: var(--fd-green);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--font-body);
  transition: background 0.15s;
}

.btn-primary:hover { background: var(--fd-green-light); }

.btn-secondary {
  background: none;
  color: var(--fd-text);
  border: 1px solid var(--fd-border);
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--font-body);
  transition: all 0.15s;
}

.btn-secondary:hover { background: var(--fd-surface2); }

.profile-tabs {
  border-bottom: 1px solid var(--fd-border);
  display: flex;
  gap: 0;
  margin-top: 16px;
}

.profile-tab {
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  font-family: var(--font-head);
  color: var(--fd-muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.15s;
}

.profile-tab.active {
  color: var(--fd-green-light);
  border-bottom-color: var(--fd-green-light);
}

.games-watched-list { margin-top: 16px; }

.game-watched-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: var(--fd-surface);
  border: 1px solid var(--fd-border);
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.game-watched-item:hover { border-color: rgba(255,255,255,0.15); }

.watched-score-tag {
  font-family: var(--font-head);
  font-size: 13px;
  font-weight: 800;
  color: var(--fd-gold);
  white-space: nowrap;
  min-width: 70px;
}

.watched-game-info { flex: 1 1; }
.watched-game-title { font-size: 13px; font-weight: 600; }
.watched-game-date { font-size: 11px; color: var(--fd-muted); margin-top: 1px; }

.watched-stars {
  display: flex;
  gap: 1px;
}

.watched-stars .star { font-size: 12px; }

/* WRAPPED / EOY page */
.wrapped-locked {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
}

.lock-icon {
  width: 72px;
  height: 72px;
  background: rgba(232,176,75,0.1);
  border: 1px solid rgba(232,176,75,0.25);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: var(--fd-gold);
  margin-bottom: 20px;
}

.wrapped-title {
  font-family: var(--font-head);
  font-size: 32px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.wrapped-sub {
  font-size: 14px;
  color: var(--fd-muted);
  max-width: 300px;
  line-height: 1.6;
}

.countdown-grid {
  display: flex;
  gap: 16px;
  margin: 28px 0;
}

.countdown-block {
  background: var(--fd-surface2);
  border: 1px solid var(--fd-border);
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 64px;
  text-align: center;
}

.countdown-num {
  font-family: var(--font-head);
  font-size: 28px;
  font-weight: 900;
  color: var(--fd-gold);
}

.countdown-label {
  font-size: 10px;
  color: var(--fd-muted);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 2px;
}

/* SETTINGS PAGE */
.settings-section {
  padding: 20px 24px;
  border-bottom: 1px solid var(--fd-border);
}

.settings-section-title {
  font-family: var(--font-head);
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--fd-muted);
  margin-bottom: 14px;
}

.settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255,255,255,0.04);
}

.settings-row:last-child { border-bottom: none; }

.settings-row-info .title { font-size: 14px; font-weight: 500; }
.settings-row-info .desc { font-size: 12px; color: var(--fd-muted); margin-top: 2px; }

.toggle {
  width: 38px;
  height: 22px;
  background: var(--fd-green);
  border-radius: 11px;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
}

.toggle.off { background: var(--fd-surface3); }

.toggle::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle.off::after { transform: translateX(0); }
.toggle:not(.off)::after { transform: translateX(16px); }

.team-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.team-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--fd-surface2);
  border: 1px solid var(--fd-border);
  border-radius: 20px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.team-chip.selected {
  background: rgba(26,122,74,0.2);
  border-color: var(--fd-green);
  color: var(--fd-green-light);
}

.team-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

/* VERIFY SECTION */
.verify-card {
  background: var(--fd-surface2);
  border: 1px solid rgba(88,166,255,0.2);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
}

.verify-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(88,166,255,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: var(--fd-blue);
  flex-shrink: 0;
}

.verify-info .title { font-size: 14px; font-weight: 600; }
.verify-info .desc { font-size: 12px; color: var(--fd-muted); margin-top: 3px; }

.verify-btn {
  margin-left: auto;
  background: var(--fd-blue);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  font-family: var(--font-body);
}

/* FRIENDS */
.friends-list { padding: 16px 24px; }

.friend-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255,255,255,0.04);
}

.friend-row:last-child { border-bottom: none; }

.friend-info { flex: 1 1; }
.friend-name { font-size: 14px; font-weight: 600; }
.friend-handle { font-size: 11px; color: var(--fd-muted); }

.friend-action {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 20px;
  cursor: pointer;
  border: 1px solid;
  transition: all 0.15s;
  font-family: var(--font-body);
}

.friend-action.following {
  background: rgba(26,122,74,0.15);
  border-color: var(--fd-green);
  color: var(--fd-green-light);
}

.friend-action.fan {
  background: rgba(232,176,75,0.1);
  border-color: rgba(232,176,75,0.4);
  color: var(--fd-gold);
}

.friend-action.add {
  background: none;
  border-color: var(--fd-border);
  color: var(--fd-muted);
}

.fan-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 10px;
  background: rgba(232,176,75,0.12);
  color: var(--fd-gold);
  margin-left: 6px;
}

/* SCROLL FIX */
.chat-panel-scroll, .reviews-panel-scroll {
  height: calc(100vh - 53px - 90px - 44px - 46px - 40px);
  overflow-y: auto;
  padding: 12px 16px;
}

/* REVIEW FORM */
.review-form-card {
  background: var(--fd-surface);
  border: 1px solid var(--fd-border);
  border-radius: 12px;
  padding: 16px;
  margin: 16px 24px;
}

.review-form-title {
  font-family: var(--font-head);
  font-size: 15px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.star-select {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
}

.star-pick {
  font-size: 22px;
  cursor: pointer;
  opacity: 0.3;
  transition: opacity 0.1s, transform 0.1s;
}

.star-pick.on { opacity: 1; }
.star-pick:hover { transform: scale(1.2); }

.review-textarea {
  width: 100%;
  background: var(--fd-surface2);
  border: 1px solid var(--fd-border);
  border-radius: 8px;
  padding: 10px 12px;
  color: var(--fd-text);
  font-family: var(--font-body);
  font-size: 13px;
  resize: none;
  min-height: 72px;
  outline: none;
  margin-bottom: 10px;
}

.review-textarea:focus { border-color: var(--fd-green); }

.review-form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.visibility-toggle {
  display: flex;
  gap: 0;
  background: var(--fd-surface2);
  border-radius: 20px;
  border: 1px solid var(--fd-border);
  padding: 3px;
}

.vis-opt {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.15s;
  color: var(--fd-muted);
}

.vis-opt.active {
  background: var(--fd-surface);
  color: var(--fd-text);
}

/* NOTIFICATIONS */
.notif-dot {
  width: 7px;
  height: 7px;
  background: var(--fd-red);
  border-radius: 50%;
  margin-left: auto;
  flex-shrink: 0;
}

/* SCROLLBAR */
::-webkit-scrollbar { width: 4px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--fd-surface2); border-radius: 2px; }

/* Button */
.sign-button {
  background-color: var(--fd-green-light);
  color: white;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 12px;
  font-size: 14px;
  height: 40px;
  width: 120px;
  border-color: var(--fd-green-light);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB,8BAA8B,EAAE,qBAAqB,EAAE;AACzE,mBAAmB,+BAA+B,EAAE,4BAA4B,EAAE;AAClF,gBAAgB,eAAe,EAAE;;AAEjC;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA,mBAAmB,8BAA8B,EAAE;;AAEnD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yBAAyB,eAAe,EAAE,gBAAgB,EAAE;AAC5D,2BAA2B,eAAe,EAAE,sBAAsB,EAAE;;AAEpE,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,UAAU;AACV,QAAQ,aAAa,EAAE;AACvB,eAAe,cAAc,EAAE;;AAE/B,cAAc;AACd;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;EAC1B,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,YAAY,EAAE,qBAAqB,EAAE;AAC7C;;AAEA,gBAAgB,kBAAkB,EAAE;;AAEpC,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,gEAAgE;AAClE;;AAEA,2BAA2B,8DAA8D,EAAE;;AAE3F,oBAAoB,oCAAoC,EAAE,2BAA2B,EAAE;;AAEvF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,oBAAoB,2BAA2B,EAAE,iBAAiB,EAAE;;AAEpE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gCAAgC;EAChC,MAAM;EACN,YAAY;AACd;;AAEA,aAAa,UAAU,EAAE,gBAAgB,EAAE;AAC3C,gBAAgB,uCAAuC,EAAE,gBAAgB,EAAE,6BAA6B,EAAE;;AAE1G;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB,2BAA2B,EAAE,iBAAiB,EAAE;;AAElE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,yCAAyC;EACzC,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,cAAc,4BAA4B,EAAE,0CAA0C,EAAE;AACxF,0BAA0B,qBAAqB,EAAE;;AAEjD,SAAS;AACT,gBAAgB,aAAa,EAAE;;AAE/B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA,oBAAoB,6BAA6B,EAAE;;AAEnD;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,kBAAkB,iCAAiC,EAAE;;AAErD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,YAAY,SAAO,EAAE;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc,eAAe,EAAE,sBAAsB,EAAE;AACvD,YAAY,eAAe,EAAE,sBAAsB,EAAE,iBAAiB,EAAE;;AAExE;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,aAAa,eAAe,EAAE;;AAE9B,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA,QAAQ,qBAAqB,EAAE,eAAe,EAAE;AAChD,cAAc,sBAAsB,EAAE;;AAEtC;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,0EAA0E;EAC1E,kBAAkB;AACpB;;AAEA,mBAAmB,oBAAoB,EAAE;;AAEzC;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kBAAkB,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;AAC5E,eAAe,eAAe,EAAE,qBAAqB,EAAE,aAAa,EAAE,gBAAgB,EAAE;;AAExF;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,qBAAqB,iCAAiC,EAAE;;AAExD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,uBAAuB,8BAA8B,EAAE;;AAEvD;EACE,yCAAyC;EACzC,aAAa;EACb,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,sBAAsB,gBAAgB,EAAE;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA,2BAA2B,oCAAoC,EAAE;;AAEjE;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qBAAqB,SAAO,EAAE;AAC9B,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;AACzD,qBAAqB,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAE/E;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,uBAAuB,eAAe,EAAE;;AAExC,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,+CAA+C;AACjD;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD,4BAA4B,eAAe,EAAE,gBAAgB,EAAE;AAC/D,2BAA2B,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAErF;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc,8BAA8B,EAAE;;AAE9C;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,qBAAqB,wBAAwB,EAAE;AAC/C,2BAA2B,2BAA2B,EAAE;;AAExD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;AACzD,qBAAqB,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAE/E;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA,YAAY;AACZ,gBAAgB,kBAAkB,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,+CAA+C;AACjD;;AAEA,yBAAyB,mBAAmB,EAAE;;AAE9C,eAAe,SAAO,EAAE;AACxB,eAAe,eAAe,EAAE,gBAAgB,EAAE;AAClD,iBAAiB,eAAe,EAAE,sBAAsB,EAAE;;AAE1D;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,sDAAsD;EACtD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,gBAAgB,UAAU,EAAE;AAC5B,mBAAmB,qBAAqB,EAAE;;AAE1C;EACE,WAAW;EACX,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,yBAAyB,6BAA6B,EAAE;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,MAAM;EACN,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,cAAc;AACd,sBAAsB,UAAU,EAAE;AAClC,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,8BAA8B,EAAE,kBAAkB,EAAE;;AAEhF,WAAW;AACX;EACE,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mCAAmC;AACrC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@400;500;600&display=swap');\n@import url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@master/css/themify-icons.css');\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --fd-green: #1a7a4a;\n  --fd-green-light: #23a862;\n  --fd-green-dark: #0f4d2d;\n  --fd-gold: #e8b04b;\n  --fd-gold-light: #f5ca70;\n  --fd-dark: #0d1117;\n  --fd-surface: #161b22;\n  --fd-surface2: #1e252e;\n  --fd-surface3: #252c36;\n  --fd-border: rgba(255,255,255,0.08);\n  --fd-text: #e6edf3;\n  --fd-muted: #8b949e;\n  --fd-red: #cf6679;\n  --fd-blue: #58a6ff;\n  --font-head: 'Barlow Condensed', sans-serif;\n  --font-body: 'Barlow', sans-serif;\n}\n\nbody {\n  background: var(--fd-dark);\n  color: var(--fd-text);\n  font-family: var(--font-body);\n  font-size: 14px;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n.app-shell {\n  display: flex;\n  height: 100vh;\n  min-height: 700px;\n  position: relative;\n  overflow: hidden;\n}\n\n/* SIDEBAR */\n.sidebar {\n  width: 220px;\n  flex-shrink: 0;\n  background: var(--fd-surface);\n  border-right: 1px solid var(--fd-border);\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  z-index: 10;\n}\n\n.logo {\n  padding: 20px 16px 16px;\n  border-bottom: 1px solid var(--fd-border);\n}\n\n.logo-text {\n  font-family: var(--font-head);\n  font-size: 26px;\n  font-weight: 900;\n  letter-spacing: -0.5px;\n  color: var(--fd-text);\n  text-transform: uppercase;\n}\n\n.logo-text span {\n  color: var(--fd-green-light);\n}\n\n.logo-sub {\n  font-size: 10px;\n  color: var(--fd-muted);\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-top: 2px;\n}\n\n.nav {\n  padding: 12px 8px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.nav-label {\n  font-size: 10px;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--fd-muted);\n  padding: 8px 8px 4px;\n  font-weight: 600;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fd-muted);\n  transition: all 0.15s;\n  margin-bottom: 2px;\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n}\n\n.nav-item:hover { background: var(--fd-surface2); color: var(--fd-text); }\n.nav-item.active { background: rgba(26,122,74,0.2); color: var(--fd-green-light); }\n.nav-item .ti { font-size: 18px; }\n\n.nav-item .badge {\n  margin-left: auto;\n  background: var(--fd-green);\n  color: #fff;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 1px 6px;\n  min-width: 18px;\n  text-align: center;\n}\n\n.sidebar-bottom {\n  padding: 12px 8px;\n  border-top: 1px solid var(--fd-border);\n}\n\n.user-pill {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.user-pill:hover { background: var(--fd-surface2); }\n\n.avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--fd-green), var(--fd-green-dark));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-head);\n  font-size: 14px;\n  font-weight: 800;\n  color: #fff;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.avatar.verified::after {\n  content: '✓';\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 14px;\n  height: 14px;\n  background: var(--fd-blue);\n  border-radius: 50%;\n  font-size: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  border: 1.5px solid var(--fd-surface);\n  font-weight: 900;\n  line-height: 14px;\n  text-align: center;\n}\n\n.user-info-small .name { font-size: 13px; font-weight: 600; }\n.user-info-small .handle { font-size: 11px; color: var(--fd-muted); }\n\n/* MAIN CONTENT */\n.main {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: var(--fd-dark);\n}\n\n/* PAGES */\n.page { display: none; }\n.page.active { display: block; }\n\n/* FEED PAGE */\n.page-header {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background: rgba(13,17,23,0.92);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid var(--fd-border);\n  padding: 14px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.page-title {\n  font-family: var(--font-head);\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.live-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(207,102,121,0.15);\n  border: 1px solid rgba(207,102,121,0.3);\n  border-radius: 20px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--fd-red);\n}\n\n.pulse-dot {\n  width: 7px;\n  height: 7px;\n  background: var(--fd-red);\n  border-radius: 50%;\n  animation: pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.5; transform: scale(0.8); }\n}\n\n.feed-content { padding: 20px 24px; }\n\n/* SCORE CARDS */\n.score-card {\n  background: var(--fd-surface);\n  border: 1px solid var(--fd-border);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n  overflow: hidden;\n}\n\n.score-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, var(--fd-green), transparent);\n}\n\n.score-card.live::before { background: linear-gradient(90deg, var(--fd-red), transparent); }\n\n.score-card:hover { border-color: rgba(255,255,255,0.15); transform: translateY(-1px); }\n\n.score-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.sport-tag {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--fd-muted);\n}\n\n.live-tag {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--fd-red);\n  background: rgba(207,102,121,0.12);\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.score-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.team-block {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.team-block.right { flex-direction: row-reverse; text-align: right; }\n\n.team-logo {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-head);\n  font-size: 13px;\n  font-weight: 900;\n  flex-shrink: 0;\n}\n\n.team-name {\n  font-family: var(--font-head);\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n}\n\n.team-record {\n  font-size: 11px;\n  color: var(--fd-muted);\n  margin-top: 1px;\n}\n\n.score-center {\n  text-align: center;\n  min-width: 90px;\n}\n\n.score-nums {\n  font-family: var(--font-head);\n  font-size: 32px;\n  font-weight: 900;\n  letter-spacing: -1px;\n  line-height: 1;\n}\n\n.score-period {\n  font-size: 11px;\n  color: var(--fd-muted);\n  margin-top: 4px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.score-card-footer {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid var(--fd-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.betting-line {\n  font-size: 12px;\n  color: var(--fd-gold);\n  font-weight: 600;\n}\n\n.chat-count {\n  font-size: 12px;\n  color: var(--fd-muted);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* SECTION TITLE */\n.section-title {\n  font-family: var(--font-head);\n  font-size: 15px;\n  font-weight: 800;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--fd-muted);\n  margin: 20px 0 10px;\n}\n\n/* GAME DETAIL PAGE */\n.game-detail-layout {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 0;\n  height: 100%;\n}\n\n.game-main { padding: 0; overflow-y: auto; }\n.game-sidebar { border-left: 1px solid var(--fd-border); overflow-y: auto; background: var(--fd-surface); }\n\n.big-scoreboard {\n  background: var(--fd-surface);\n  border-bottom: 1px solid var(--fd-border);\n  padding: 24px;\n}\n\n.big-score-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.big-team {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.big-team.right { flex-direction: row-reverse; text-align: right; }\n\n.big-logo {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-head);\n  font-size: 18px;\n  font-weight: 900;\n  flex-shrink: 0;\n}\n\n.big-team-name {\n  font-family: var(--font-head);\n  font-size: 24px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.big-score {\n  text-align: center;\n}\n\n.big-score-nums {\n  font-family: var(--font-head);\n  font-size: 52px;\n  font-weight: 900;\n  letter-spacing: -2px;\n  line-height: 1;\n}\n\n.big-score-period {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--fd-red);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-top: 4px;\n}\n\n.odds-bar {\n  display: flex;\n  gap: 16px;\n  padding: 12px 24px;\n  background: rgba(232,176,75,0.06);\n  border-bottom: 1px solid var(--fd-border);\n  align-items: center;\n}\n\n.odd-item {\n  font-size: 12px;\n  color: var(--fd-muted);\n}\n\n.odd-item span {\n  color: var(--fd-gold);\n  font-weight: 700;\n  margin-left: 4px;\n}\n\n/* TABS */\n.tabs {\n  display: flex;\n  border-bottom: 1px solid var(--fd-border);\n  padding: 0 24px;\n  background: var(--fd-dark);\n  position: sticky;\n  top: 53px;\n  z-index: 4;\n}\n\n.tab {\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fd-muted);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.15s;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  font-family: var(--font-head);\n}\n\n.tab.active { color: var(--fd-green-light); border-bottom-color: var(--fd-green-light); }\n.tab:hover:not(.active) { color: var(--fd-text); }\n\n/* CHAT */\n.chat-section { padding: 16px; }\n\n.chat-input-area {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  align-items: flex-end;\n}\n\n.chat-input {\n  flex: 1;\n  background: var(--fd-surface2);\n  border: 1px solid var(--fd-border);\n  border-radius: 10px;\n  padding: 10px 14px;\n  color: var(--fd-text);\n  font-family: var(--font-body);\n  font-size: 13px;\n  resize: none;\n  min-height: 40px;\n  max-height: 80px;\n  outline: none;\n}\n\n.chat-input:focus { border-color: var(--fd-green); }\n\n.send-btn {\n  background: var(--fd-green);\n  border: none;\n  border-radius: 8px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #fff;\n  font-size: 16px;\n  transition: background 0.15s;\n  flex-shrink: 0;\n}\n\n.send-btn:hover { background: var(--fd-green-light); }\n\n.chat-message {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 14px;\n  align-items: flex-start;\n}\n\n.msg-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-head);\n  font-size: 11px;\n  font-weight: 800;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.msg-avatar.verified::after {\n  content: '✓';\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 12px;\n  height: 12px;\n  background: var(--fd-blue);\n  border-radius: 50%;\n  font-size: 7px;\n  line-height: 12px;\n  text-align: center;\n  color: #fff;\n  border: 1.5px solid var(--fd-dark);\n  font-weight: 900;\n}\n\n.msg-body { flex: 1; }\n\n.msg-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 3px;\n}\n\n.msg-name {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.msg-handle { font-size: 11px; color: var(--fd-muted); }\n.msg-time { font-size: 11px; color: var(--fd-muted); margin-left: auto; }\n\n.msg-text {\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--fd-text);\n  background: var(--fd-surface2);\n  padding: 8px 12px;\n  border-radius: 0 10px 10px 10px;\n  display: inline-block;\n  max-width: 100%;\n}\n\n.foam-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.foam-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: 1px solid var(--fd-border);\n  border-radius: 20px;\n  padding: 3px 10px;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--fd-muted);\n  transition: all 0.15s;\n  font-family: var(--font-body);\n}\n\n.foam-btn:hover, .foam-btn.active {\n  background: rgba(232,176,75,0.12);\n  border-color: rgba(232,176,75,0.4);\n  color: var(--fd-gold);\n}\n\n.foam-icon { font-size: 14px; }\n\n/* REVIEW CARD */\n.review-card {\n  background: var(--fd-surface2);\n  border: 1px solid var(--fd-border);\n  border-radius: 10px;\n  padding: 14px;\n  margin-bottom: 12px;\n}\n\n.review-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.stars {\n  display: flex;\n  gap: 2px;\n  margin-left: auto;\n}\n\n.star { color: var(--fd-gold); font-size: 14px; }\n.star.empty { color: var(--fd-muted); }\n\n.review-text {\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--fd-text);\n  margin-bottom: 10px;\n}\n\n.review-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.visibility-badge {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: 20px;\n}\n\n.visibility-badge.public {\n  background: rgba(35,168,98,0.15);\n  color: var(--fd-green-light);\n}\n\n.visibility-badge.friends {\n  background: rgba(88,166,255,0.12);\n  color: var(--fd-blue);\n}\n\n/* PROFILE PAGE */\n.profile-hero {\n  height: 120px;\n  background: linear-gradient(135deg, var(--fd-green-dark) 0%, #0d1117 100%);\n  position: relative;\n}\n\n.profile-content { padding: 0 24px 24px; }\n\n.profile-avatar-wrap {\n  margin-top: -30px;\n  margin-bottom: 12px;\n}\n\n.profile-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--fd-green), var(--fd-green-dark));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-head);\n  font-size: 24px;\n  font-weight: 900;\n  color: #fff;\n  border: 3px solid var(--fd-dark);\n  position: relative;\n}\n\n.profile-avatar.verified::after {\n  content: '✓';\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 20px;\n  height: 20px;\n  background: var(--fd-blue);\n  border-radius: 50%;\n  font-size: 10px;\n  line-height: 20px;\n  text-align: center;\n  color: #fff;\n  border: 2px solid var(--fd-dark);\n  font-weight: 900;\n}\n\n.profile-name {\n  font-family: var(--font-head);\n  font-size: 22px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.profile-handle { font-size: 13px; color: var(--fd-muted); margin-top: 2px; }\n.profile-bio { font-size: 13px; color: var(--fd-text); margin: 8px 0; line-height: 1.5; }\n\n.profile-stats {\n  display: flex;\n  gap: 20px;\n  margin: 12px 0;\n}\n\n.profile-stat {\n  text-align: center;\n}\n\n.profile-stat .num {\n  font-family: var(--font-head);\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.profile-stat .label {\n  font-size: 11px;\n  color: var(--fd-muted);\n  margin-top: 1px;\n}\n\n.profile-actions {\n  display: flex;\n  gap: 8px;\n  margin: 14px 0;\n}\n\n.btn-primary {\n  background: var(--fd-green);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: var(--font-body);\n  transition: background 0.15s;\n}\n\n.btn-primary:hover { background: var(--fd-green-light); }\n\n.btn-secondary {\n  background: none;\n  color: var(--fd-text);\n  border: 1px solid var(--fd-border);\n  border-radius: 8px;\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: var(--font-body);\n  transition: all 0.15s;\n}\n\n.btn-secondary:hover { background: var(--fd-surface2); }\n\n.profile-tabs {\n  border-bottom: 1px solid var(--fd-border);\n  display: flex;\n  gap: 0;\n  margin-top: 16px;\n}\n\n.profile-tab {\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  font-family: var(--font-head);\n  color: var(--fd-muted);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.15s;\n}\n\n.profile-tab.active {\n  color: var(--fd-green-light);\n  border-bottom-color: var(--fd-green-light);\n}\n\n.games-watched-list { margin-top: 16px; }\n\n.game-watched-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: var(--fd-surface);\n  border: 1px solid var(--fd-border);\n  border-radius: 8px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.game-watched-item:hover { border-color: rgba(255,255,255,0.15); }\n\n.watched-score-tag {\n  font-family: var(--font-head);\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--fd-gold);\n  white-space: nowrap;\n  min-width: 70px;\n}\n\n.watched-game-info { flex: 1; }\n.watched-game-title { font-size: 13px; font-weight: 600; }\n.watched-game-date { font-size: 11px; color: var(--fd-muted); margin-top: 1px; }\n\n.watched-stars {\n  display: flex;\n  gap: 1px;\n}\n\n.watched-stars .star { font-size: 12px; }\n\n/* WRAPPED / EOY page */\n.wrapped-locked {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 24px;\n  text-align: center;\n}\n\n.lock-icon {\n  width: 72px;\n  height: 72px;\n  background: rgba(232,176,75,0.1);\n  border: 1px solid rgba(232,176,75,0.25);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n  color: var(--fd-gold);\n  margin-bottom: 20px;\n}\n\n.wrapped-title {\n  font-family: var(--font-head);\n  font-size: 32px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 8px;\n}\n\n.wrapped-sub {\n  font-size: 14px;\n  color: var(--fd-muted);\n  max-width: 300px;\n  line-height: 1.6;\n}\n\n.countdown-grid {\n  display: flex;\n  gap: 16px;\n  margin: 28px 0;\n}\n\n.countdown-block {\n  background: var(--fd-surface2);\n  border: 1px solid var(--fd-border);\n  border-radius: 10px;\n  padding: 14px 16px;\n  min-width: 64px;\n  text-align: center;\n}\n\n.countdown-num {\n  font-family: var(--font-head);\n  font-size: 28px;\n  font-weight: 900;\n  color: var(--fd-gold);\n}\n\n.countdown-label {\n  font-size: 10px;\n  color: var(--fd-muted);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-top: 2px;\n}\n\n/* SETTINGS PAGE */\n.settings-section {\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--fd-border);\n}\n\n.settings-section-title {\n  font-family: var(--font-head);\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--fd-muted);\n  margin-bottom: 14px;\n}\n\n.settings-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n}\n\n.settings-row:last-child { border-bottom: none; }\n\n.settings-row-info .title { font-size: 14px; font-weight: 500; }\n.settings-row-info .desc { font-size: 12px; color: var(--fd-muted); margin-top: 2px; }\n\n.toggle {\n  width: 38px;\n  height: 22px;\n  background: var(--fd-green);\n  border-radius: 11px;\n  position: relative;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.toggle.off { background: var(--fd-surface3); }\n\n.toggle::after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n\n.toggle.off::after { transform: translateX(0); }\n.toggle:not(.off)::after { transform: translateX(16px); }\n\n.team-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.team-chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--fd-surface2);\n  border: 1px solid var(--fd-border);\n  border-radius: 20px;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.team-chip.selected {\n  background: rgba(26,122,74,0.2);\n  border-color: var(--fd-green);\n  color: var(--fd-green-light);\n}\n\n.team-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n/* VERIFY SECTION */\n.verify-card {\n  background: var(--fd-surface2);\n  border: 1px solid rgba(88,166,255,0.2);\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.verify-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(88,166,255,0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: var(--fd-blue);\n  flex-shrink: 0;\n}\n\n.verify-info .title { font-size: 14px; font-weight: 600; }\n.verify-info .desc { font-size: 12px; color: var(--fd-muted); margin-top: 3px; }\n\n.verify-btn {\n  margin-left: auto;\n  background: var(--fd-blue);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 7px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  flex-shrink: 0;\n  font-family: var(--font-body);\n}\n\n/* FRIENDS */\n.friends-list { padding: 16px 24px; }\n\n.friend-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n}\n\n.friend-row:last-child { border-bottom: none; }\n\n.friend-info { flex: 1; }\n.friend-name { font-size: 14px; font-weight: 600; }\n.friend-handle { font-size: 11px; color: var(--fd-muted); }\n\n.friend-action {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 5px 12px;\n  border-radius: 20px;\n  cursor: pointer;\n  border: 1px solid;\n  transition: all 0.15s;\n  font-family: var(--font-body);\n}\n\n.friend-action.following {\n  background: rgba(26,122,74,0.15);\n  border-color: var(--fd-green);\n  color: var(--fd-green-light);\n}\n\n.friend-action.fan {\n  background: rgba(232,176,75,0.1);\n  border-color: rgba(232,176,75,0.4);\n  color: var(--fd-gold);\n}\n\n.friend-action.add {\n  background: none;\n  border-color: var(--fd-border);\n  color: var(--fd-muted);\n}\n\n.fan-badge {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 10px;\n  background: rgba(232,176,75,0.12);\n  color: var(--fd-gold);\n  margin-left: 6px;\n}\n\n/* SCROLL FIX */\n.chat-panel-scroll, .reviews-panel-scroll {\n  height: calc(100vh - 53px - 90px - 44px - 46px - 40px);\n  overflow-y: auto;\n  padding: 12px 16px;\n}\n\n/* REVIEW FORM */\n.review-form-card {\n  background: var(--fd-surface);\n  border: 1px solid var(--fd-border);\n  border-radius: 12px;\n  padding: 16px;\n  margin: 16px 24px;\n}\n\n.review-form-title {\n  font-family: var(--font-head);\n  font-size: 15px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n}\n\n.star-select {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.star-pick {\n  font-size: 22px;\n  cursor: pointer;\n  opacity: 0.3;\n  transition: opacity 0.1s, transform 0.1s;\n}\n\n.star-pick.on { opacity: 1; }\n.star-pick:hover { transform: scale(1.2); }\n\n.review-textarea {\n  width: 100%;\n  background: var(--fd-surface2);\n  border: 1px solid var(--fd-border);\n  border-radius: 8px;\n  padding: 10px 12px;\n  color: var(--fd-text);\n  font-family: var(--font-body);\n  font-size: 13px;\n  resize: none;\n  min-height: 72px;\n  outline: none;\n  margin-bottom: 10px;\n}\n\n.review-textarea:focus { border-color: var(--fd-green); }\n\n.review-form-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.visibility-toggle {\n  display: flex;\n  gap: 0;\n  background: var(--fd-surface2);\n  border-radius: 20px;\n  border: 1px solid var(--fd-border);\n  padding: 3px;\n}\n\n.vis-opt {\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: all 0.15s;\n  color: var(--fd-muted);\n}\n\n.vis-opt.active {\n  background: var(--fd-surface);\n  color: var(--fd-text);\n}\n\n/* NOTIFICATIONS */\n.notif-dot {\n  width: 7px;\n  height: 7px;\n  background: var(--fd-red);\n  border-radius: 50%;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n/* SCROLLBAR */\n::-webkit-scrollbar { width: 4px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: var(--fd-surface2); border-radius: 2px; }\n\n/* Button */\n.sign-button {\n  background-color: var(--fd-green-light);\n  color: white;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  border-radius: 12px;\n  font-size: 14px;\n  height: 40px;\n  width: 120px;\n  border-color: var(--fd-green-light);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
